import React from 'react'

const Finances = () => {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-blue-900 text-3xl text-white"
        >
            <div>This is Finances </div>
        </div>
    )
}

export default Finances
